<template>
  <div class="login-container">
    <div class="login-content">
      <div class="left-section">
        <el-carousel 
          :interval="10000" 
          arrow="hover" 
          :autoplay="true"
          indicator-position="none"
          height="100%"
          ref="carousel">
          <el-carousel-item v-for="(img, index) in carouselImages" :key="index">
            <img :src="img" :alt="`机甲图片${index + 1}`" class="mecha-image">
          </el-carousel-item>
        </el-carousel>
        <div class="custom-indicators">
          <span
            v-for="(_, index) in carouselImages"
            :key="index"
            :class="['indicator-dot', { active: currentIndex === index }]"
            @click="setActiveItem(index)">
          </span>
        </div>
      </div>
      <div class="right-section">
        <div class="login-box">
          <div class="title-container">
            <h2 class="title">你的 <span class="highlight-o">O</span>Ier 之路</h2>
            <p class="subtitle">探索算法的无限可能</p>
          </div>
          
          <el-form :model="form" :rules="rules" ref="form" class="login-form">
            <el-form-item prop="username">
              <el-input
                v-model="form.username"
                placeholder="用户名"
                prefix-icon="el-icon-user"
                @keyup.enter.native="handleLogin"
                autocomplete="off">
              </el-input>
            </el-form-item>
            
            <el-form-item prop="password">
              <el-input
                v-model="form.password"
                type="password"
                placeholder="密码"
                prefix-icon="el-icon-lock"
                @keyup.enter.native="handleLogin"
                autocomplete="off">
              </el-input>
            </el-form-item>
            
            <el-form-item prop="captcha">
              <div class="captcha-container">
                <el-input
                  v-model="form.captcha"
                  placeholder="验证码"
                  prefix-icon="el-icon-key"
                  @keyup.enter.native="handleLogin"
                  autocomplete="off">
                </el-input>
                <img :src="captchaUrl" @click="refreshCaptcha" class="captcha-img" alt="验证码">
              </div>
            </el-form-item>
            
            <el-form-item>
              <el-button type="primary" :loading="loading" @click="handleLogin" class="login-button">
                {{ loading ? '登录中...' : '登录' }}
              </el-button>
            </el-form-item>
          </el-form>

          <div class="copyright">
            Copyright © 2024 OIer之路<br>闽ICP备2025095302号-1
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import request from '@/utils/request'

export default {
  name: 'Login',
  data() {
    return {
      form: {
        username: '',
        password: '',
        captcha: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      loading: false,
      captchaUrl: '/api/captcha',
      carouselImages: [
        require('../assets/images/login/mecha-1.jpg'),
        require('../assets/images/login/mecha-12.jpg'),
        require('../assets/images/login/mecha-13.jpg'),
        require('../assets/images/login/mecha-4.jpg')
      ],
      currentIndex: 0
      ,
      observer: null
    }
  },
  created() {
    this.refreshCaptcha()
  },
  methods: {
    refreshCaptcha() {
      this.captchaUrl = `/api/captcha?t=${new Date().getTime()}`
    },
    handleLogin() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          request({
            url: '/api/user/login',
            method: 'post',
            data: this.form
          }).then(res => {
            if (res.code === 200) {
              localStorage.setItem('token', 'logged_in')
              localStorage.setItem('userInfo', JSON.stringify(res.data))
              this.$message.success('登录成功')
              this.$router.push('/')
            } else {
              this.$message.error(res.message || '登录失败')
            }
          }).catch(err => {
            this.$message.error(err.message || '登录失败')
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    setActiveItem(index) {
      this.$refs.carousel.setActiveItem(index)
      this.currentIndex = index
    },
    handleCarouselChange(index) {
      this.currentIndex = index
    },
    // 隐藏 App.vue 中的全局移动端按钮（菜单/回到顶部）
    hideGlobalButtons() {
      const selectors = ['#app > .mobile-menu-btn', '#app > .back-to-top-btn', 'body > #app > .mobile-menu-btn', 'body > #app > .back-to-top-btn']
      selectors.forEach(sel => {
        const nodes = document.querySelectorAll(sel)
        nodes.forEach(node => {
          node.style.display = 'none'
          node.setAttribute('style', 'display: none !important')
        })
      })
    },
    // 恢复全局按钮显示（仅在移动端下恢复）
    restoreGlobalButtons() {
      const isMobile = window.innerWidth <= 768
      if (!isMobile) return
      const selectors = ['#app > .mobile-menu-btn', '#app > .back-to-top-btn']
      selectors.forEach(sel => {
        const node = document.querySelector(sel)
        if (node) {
          node.style.display = 'flex'
        }
      })
    },
    // 监听 DOM 变化，确保按钮被持续隐藏
    setupMutationObserver() {
      if (this.observer) {
        this.observer.disconnect()
      }
      this.observer = new MutationObserver(() => {
        this.hideGlobalButtons()
      })
      this.observer.observe(document.body, { childList: true, subtree: true })
    }
  },
  mounted() {
    this.$nextTick(() => {
      const carousel = this.$refs.carousel
      if (carousel) {
        carousel.$on('change', this.handleCarouselChange)
      }
    })
    // 屏蔽全局按钮（与博客一致）
    this.hideGlobalButtons()
    setTimeout(() => this.hideGlobalButtons(), 100)
    this.setupMutationObserver()
  },
  beforeDestroy() {
    const carousel = this.$refs.carousel
    if (carousel) {
      carousel.$off('change', this.handleCarouselChange)
    }
    // 清理观察器并尝试恢复（离开登录页后）
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
    this.restoreGlobalButtons()
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #0a192f 0%, #000000 100%);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    width: 200%;
    height: 200%;
    background: repeating-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.03) 0px,
      rgba(255, 255, 255, 0.03) 1px,
      transparent 1px,
      transparent 10px
    );
    animation: backgroundMove 20s linear infinite;
  }

  .login-content {
    display: flex;
    width: 80%;
    max-width: 1600px;
    height: 600px;
    position: relative;
    z-index: 1;
    max-height: 90vh;
    overflow: hidden;

    .left-section {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      border-radius: 15px 0 0 15px;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 100px;
        height: 100%;
        background: linear-gradient(to right, transparent, rgba(10, 25, 47, 0.8));
        z-index: 2;
      }

      :deep(.el-carousel),
      :deep(.el-carousel__container) {
        width: 100%;
        height: 100%;
      }

      :deep(.el-carousel__arrow) {
        background-color: rgba(0, 0, 0, 0.3);
        opacity: 0;
        transition: all 0.5s ease;
        
        &:hover {
          background-color: rgba(0, 0, 0, 0.5);
        }
      }

      &:hover {
        :deep(.el-carousel__arrow) {
          opacity: 1;
        }
      }

      .mecha-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }

      .custom-indicators {
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
        display: flex;
        gap: 8px;
        
        .indicator-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: rgba(255, 255, 255, 0.4);
          cursor: pointer;
          transition: all 0.3s ease;
          
          &:hover {
            background-color: rgba(255, 255, 255, 0.8);
          }
          
          &.active {
            width: 24px;
            border-radius: 4px;
            background-color: #fff;
          }
        }
      }
    }

    .right-section {
      width: 420px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.03);
      backdrop-filter: blur(10px);
      border-radius: 0 15px 15px 0;
      box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
      border: 1px solid rgba(255, 255, 255, 0.1);

      .login-box {
        width: 100%;
        padding: 40px;

        .title-container {
          text-align: center;
          margin-bottom: 40px;
          
          .title {
            font-size: 32px;
            color: #fff;
            margin: 0;
            font-weight: 600;
            letter-spacing: 2px;
            text-shadow: 0 0 10px rgba(66, 133, 244, 0.5);

            .highlight-o {
              position: relative;
              color: #fff;
              text-shadow: 
                0 0 10px rgba(255, 0, 0, 0.8),
                0 0 20px rgba(255, 0, 0, 0.4);
              animation: glowing 2s ease-in-out infinite;
              
              &::after {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 120%;
                height: 120%;
                background: radial-gradient(circle, rgba(255, 0, 0, 0.3) 0%, transparent 70%);
                border-radius: 50%;
                z-index: -1;
                animation: pulse 2s ease-in-out infinite;
              }
            }
          }
          
          .subtitle {
            margin-top: 10px;
            color: rgba(255, 255, 255, 0.7);
            font-size: 16px;
          }
        }

        .login-form {
          .el-form-item {
            margin-bottom: 25px;

            .el-input {
              ::v-deep .el-input__inner {
                background: rgba(255, 255, 255, 0.05);
                border: 1px solid rgba(255, 255, 255, 0.1);
                color: #fff;
                height: 45px;
                padding-left: 45px;
                
                &::placeholder {
                  color: rgba(255, 255, 255, 0.5);
                }
              }
              
              ::v-deep .el-input__prefix {
                left: 15px;
                color: rgba(255, 255, 255, 0.7);
              }
            }
          }

          .captcha-container {
            display: flex;
            gap: 15px;
            
            .el-input {
              flex: 1;
            }
            
            .captcha-img {
              height: 45px;
              border-radius: 4px;
              cursor: pointer;
              transition: all 0.3s;
              
              &:hover {
                transform: scale(1.02);
                box-shadow: 0 0 10px rgba(66, 133, 244, 0.3);
              }
            }
          }

          .login-button {
            width: 100%;
            height: 45px;
            background: linear-gradient(45deg, #4285f4, #34a853);
            border: none;
            font-size: 16px;
            letter-spacing: 2px;
            text-transform: uppercase;
            transition: all 0.3s;
            
            &:hover {
              transform: translateY(-2px);
              box-shadow: 0 5px 15px rgba(66, 133, 244, 0.4);
            }
            
            &:active {
              transform: translateY(0);
            }
          }
        }

        .copyright {
          text-align: center;
          color: rgba(255, 255, 255, 0.5);
          font-size: 12px;
          margin-top: 20px;
        }
      }
    }
  }
}

@keyframes backgroundMove {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(-50%, -50%);
  }
}

@keyframes glowing {
  0%, 100% {
    text-shadow: 
      0 0 10px rgba(255, 0, 0, 0.8),
      0 0 20px rgba(255, 0, 0, 0.4);
  }
  50% {
    text-shadow: 
      0 0 15px rgba(255, 0, 0, 0.9),
      0 0 25px rgba(255, 0, 0, 0.6),
      0 0 35px rgba(255, 0, 0, 0.4);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.5;
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.2);
  }
}

// 错误提示样式
::v-deep .el-form-item__error {
  color: #ff4d4f;
  font-size: 12px;
  transform: translateY(2px);
}
</style> 